import { IconButton, InputBase, Menu, MenuItem, Toolbar } from "@mui/material";
import { useState } from "react";
import { MoreHoriz as MoreHorizIcon } from "@mui/icons-material";

import { logout } from "./app/auth";

function Header({
  search,
  onSearchChange,
  setShowProgressDialog,
  setShowShareLinksDialog,
  onOpenAdmin,
  onSignedOut,
}: {
  search: string;
  onSearchChange: (newSearch: string) => void;
  setShowProgressDialog: (show: boolean) => void;
  setShowShareLinksDialog: (show: boolean) => void;
  onOpenAdmin: () => void;
  onSignedOut: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const close = () => setAnchorEl(null);

  return (
    <Toolbar disableGutters sx={{ padding: 1 }}>
      <InputBase
        size="small"
        fullWidth
        placeholder="Search…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          backgroundColor: "whitesmoke",
          borderRadius: "999px",
          padding: "8px 16px",
        }}
      />
      <IconButton
        aria-label="More"
        color="inherit"
        sx={{ marginLeft: 0.5 }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        <MenuItem
          onClick={() => {
            close();
            setShowProgressDialog(true);
          }}
        >
          Progress
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            setShowShareLinksDialog(true);
          }}
        >
          Share links
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            onOpenAdmin();
          }}
        >
          Admin panel
        </MenuItem>
        <MenuItem
          onClick={async () => {
            close();
            await logout();
            onSignedOut();
          }}
        >
          Sign out
        </MenuItem>
      </Menu>
    </Toolbar>
  );
}

export default Header;
